<div>
  <form [formGroup]="formGroup">
    <div class="p-fluid formgrid grid">

      <div class="field col-12 md:col-6 lg:col-4">
        <label for="language">
          {{'InvitationCodePage.LanguageFieldLabel' | translate }}
          <span class="mandatory-field">*</span>
        </label>
        <p-dropdown
          [options]="langs"
          inputId="language"
          optionLabel="label"
          optionValue="lang"
          formControlName="language"
          (onChange)="switchLang()"
          [showClear]="false"
          placeholder="{{ 'InvitationCodePage.LanguageFieldPlaceholder' | translate}}"
          class="custom-dropdown bg-form">
          <ng-template pTemplate="selectedItem">
            <div class="flex align-items-center">
              <img [flag]="lang.icon" style="width: 18px" alt="" *ngIf="lang"/>
              <span>&nbsp;{{lang?.label}}</span>
            </div>
          </ng-template>
          <ng-template let-lang pTemplate="item">
            <div class="flex align-items-center">
              <img [flag]="lang.icon" style="width: 18px" alt=""/>
              <span>&nbsp;{{lang.label}}</span>
            </div>
          </ng-template>
        </p-dropdown>
        <small *ngIf="submit && formGroup.controls['language'].invalid" class="p-error">{{getErrorMessage('language')}}</small>
      </div>

      <div class="field col-12 md:col-6 lg:col-4">
        <label for="fullname">
          {{'InvitationCodePage.FullNameLabel' | translate }}
          <span class="mandatory-field">*</span>
        </label>
        <input
          id="fullname"
          formControlName="fullname"
          type="text"
          maxlength="120"
          required
          pInputText
          placeholder="{{'InvitationCodePage.FullNameFieldPlaceholder' | translate }}"
          [(ngModel)]="fullname"
          class="custom-input bg-form"/>
        <small *ngIf="submit && formGroup.controls['fullname'].invalid"
          class="p-error">{{getErrorMessage('fullname')}}</small>
      </div>

      <div class="field col-12 md:col-6 lg:col-4">
        <label for="email">
          {{'InvitationCodePage.EmailFieldLabel' | translate }}
          <span class="mandatory-field">*</span>
        </label>
        <input
          id="email"
          formControlName="email"
          type="text"
          maxlength="50"
          required
          pInputText
          placeholder="{{'InvitationCodePage.EmailFieldPlaceholder' | translate }}"
          [(ngModel)]="email"
          class="custom-input bg-form"/>
        <small *ngIf="submit && formGroup.controls['email'].invalid"
          class="p-error">{{getErrorMessage('email')}}</small>
      </div>

      <div class="field col-6 md:col-offset-6 md:col-3 lg:col-offset-8 lg:col-2 mt-4">
        <p-button
          label="{{'AdminUsersManagement.Messages.CancelButton' | translate}}"
          (onClick)="cancel()"
          [loading]="loading"
          styleClass="p-button-outlined"
          class="custom-text-button"/>
      </div>
      <div class="field col-6 md:col-3 lg:col-2 mt-4">
        <p-button
          class="p-button p-button-primary"
          (onClick)="generateCode()"
          label="{{'InvitationCodePage.GenerateCode' | translate}}"
          [loading]="loading"
          class="custom-text-button"/>
      </div>
    </div>
  </form>
</div>
